<template>
  <div>
    <el-form>
      <el-row>
        <el-col :span="6">
          <el-form-item label="达人名称" label-width="80px">
            <el-input
              v-model="searchForm.storeName"
              clearable
              placeholder="达人名称"
              @keyup.enter.native="getList"
            >
            </el-input> </el-form-item
        ></el-col>

        <el-col :span="6">
          <el-form-item label="联系电话" label-width="80px">
            <el-select
              v-model="searchForm.storePhone"
              class="cus_width"
              clearable
              filterable
              :filter-method="handleFilter"
              placeholder="选择联系电话"
              @change="getList"
            >
              <el-option
                v-for="item in storeList"
                :key="item.phone"
                :label="item.name + '(' + item.phone + ')'"
                :value="item.phone"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产品名称" label-width="80px">
            <el-select
              v-model="searchForm.commodityName"
              class="cus_width"
              clearable
              filterable
              placeholder="选择产品名称"
              @change="getList"
            >
              <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-button type="success" @click="getList()">搜索</el-button>
          <el-button
            v-if="hasAuth('sys:shopsetting:add')"
            style="margin-bottom: 20px"
            type="primary"
            @click="handleSet('null')"
            >添加
          </el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      style="width: 100%"
    >
      <el-table-column align="center" label="达人名称" prop="storeName" />
      <el-table-column align="center" label="达人联系方式" prop="storePhone">
      </el-table-column>
      <el-table-column align="center" label="产品名称" prop="commodityName" />
      <el-table-column
        align="center"
        label="创建时间"
        prop="createTime"
        width="160"
      />
      <el-table-column
        align="center"
        fixed="right"
        label="操作"
        prop="icon"
        width="340"
      >
        <template slot-scope="scope">
          <el-button
            slot="reference"
            plain
            style="margin-bottom: 6px"
            type="primary"
            v-if="hasAuth('sys:shopsetting:edit')"
            @click="editHandle(scope.row)"
            >编辑</el-button
          >
          <el-button
            slot="reference"
            plain
            style="margin-bottom: 6px"
            type="danger"
            v-if="hasAuth('sys:shopsetting:del')"
            @click="delHandle(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="searchForm.pageNo"
      :page-size="searchForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <el-dialog
      :before-close="handleClose"
      :title="editForm.id ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <el-form
        v-if="dialogVisible"
        ref="editForm"
        :model="editForm"
        :rules="rules"
        class="demo-editForm"
        label-width="160px"
      >
        <el-form-item label="达人" prop="storeId">
          <el-row>
            <el-col :span="18">
              <el-input v-model="editForm.storeName" disabled></el-input>
            </el-col>
            <el-col :span="4">
              <el-button
                icon="el-icon-search"
                style="height: 40px; width: 100%"
                type="primary"
                :disabled="editForm.id"
                @click="selectUser"
                >选择
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="产品" prop="commodityId" v-if="editForm.id">
          <el-select
            v-model="editForm.commodityId"
            placeholder="请选择产品"
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="item in commodityIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="产品" prop="commodityIdList" v-if="!editForm.id">
          <el-select
            v-model="editForm.commodityIdList"
            multiple
            filterable
            placeholder="请选择产品"
            style="width: 100%"
          >
            <el-option
              v-for="item in commodityIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否计算推广量" prop="type">
          <el-checkbox v-model="editForm.type" disabled>不计算</el-checkbox>
        </el-form-item>
        <div style="height: 30px"></div>
        <el-form-item>
          <el-button type="primary" @click="submitForm('editForm')"
            >提交
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :before-close="handlClose"
      :visible.sync="visible"
      append-to-body
      title="选择达人"
      width="80%"
    >
      <div style="padding-bottom: 40px">
        <el-form :inline="true">
          <el-form-item label="用户昵称" label-width="80px">
            <el-input
              v-model="userSearchForm.name"
              clearable
              placeholder="用户昵称"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="手机号" label-width="80px">
            <el-select
              v-model="userSearchForm.phone"
              class="cus_width"
              clearable
              filterable
              :filter-method="handleFilter"
              placeholder="联系电话"
              @change="getStoreGoods"
            >
              <el-option
                v-for="item in storeList"
                :key="item.phone"
                :label="item.name + '(' + item.phone + ')'"
                :value="item.phone"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="getStoreGoods()">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="userList" border stripe style="width: 100%">
          <el-table-column
            align="center"
            label="用户昵称"
            width="200"
            prop="name"
          ></el-table-column>
          <el-table-column
            align="center"
            label="用户手机号"
            width="120"
            prop="phone"
          ></el-table-column>

          <el-table-column
            align="center"
            label="位置"
            min-width="200"
            prop="address"
          ></el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            prop="icon"
            width="120"
          >
            <template slot-scope="scope">
              <el-button plain type="success" @click="userSumbit(scope.row)"
                >选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="userSearchForm.pageNo"
          :page-size="userSearchForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="usr_total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleUserSizeChange"
          @current-change="handleUserCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "shopsetting",
  data() {
    return {
      userList: [],

      tableData: [],
      dialogVisible: false,
      editForm: {
        commodityIdList: [],
        storeId: "",
        storeName: "",
        type: true,
      },
      storeList: [],
      commodityIdList: [],
      total: 0,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        commodityName: "",
        storeName: "",
        storePhone: "",
      },
      usr_total: 0,
      shopList: [],
      userSearchForm: {
        pageNo: 1,
        pageSize: 10,
        name: null,
        phone: null,
      },
      visible: false,
      rules: {
        commodityIdList: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        storeId: [{ required: true, message: "请选择", trigger: "change" }],
        type: [{ required: true, message: "请选择", trigger: "change" }],
      },
    };
  },
  created() {
    if (this.$route.query.storePhone) {
      this.searchForm.storePhone = this.$route.query.storePhone;
    }
    if (this.$route.query.storeName) {
      this.searchForm.storeName = this.$route.query.storeName;
    }
    this.getList();
    this.getCommodity();
    this.getShopList();
    this.getSearchList(this.searchForm.storePhone);
  },
  methods: {
    getShopList(val) {
      this.$axios
        .post("/admin/commodity/getUpperCommodityList", {
          pageNo: 1,
          pageSize: 99999999,
        })
        .then((res) => {
          this.shopList = res.data.records;
        });
    },

    getSearchList(val) {
      this.$axios
        .post("/admin/store/getStoreList", {
          pageNo: 1,
          pageSize: 10,
          phone: val,
        })
        .then((res) => {
          this.storeList = res.data.records;
        });
    },

    handleFilter(val) {
      this.userSearchForm.phone = val;
      this.getSearchList(val);
    },

    editHandle(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editForm.type = row.type === 1;
      this.dialogVisible = true;
    },
    userSumbit(i) {
      this.editForm.storeId = i.id;
      this.editForm.storeName = i.name;
      this.visible = false;
    },

    getUser() {
      this.$axios
        .post("/admin/store/getStoreList", this.userSearchForm)
        .then((res) => {
          this.userList = res.data.records;
          this.usr_total = res.data.total;
        });
    },
    getCommodity() {
      this.$axios
        .post("/admin/commodity/getUpperCommodityList", {
          pageNo: 1,
          pageSize: 9999,
          type: 0,
        })
        .then((res) => {
          this.commodityIdList = res.data.records;
        });
    },
    selectUser() {
      this.userSearchForm = {
        pageNo: 1,
        pageSize: 10,
        name: null,
        phone: null,
      };
      this.getUser();
      this.visible = true;
    },
    getStoreGoods() {
      this.userSearchForm.pageNo = 1;
      this.getUser();
    },
    handleUserSizeChange(val) {
      this.userSearchForm.pageSize = val;
      this.getUser();
    },
    handleUserCurrentChange(val) {
      this.userSearchForm.pageNo = val;
      this.getUser();
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getList();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editForm.id) {
            var obj = {
              commodityId: this.editForm.commodityId,
              id: this.editForm.id,
              type: this.editForm.type ? 1 : 0,
            };
            this.$axios
              .post("/admin/store/updStoreCommodity", obj)
              .then((res) => {
                this.$message({
                  showClose: true,
                  message: "恭喜你，操作成功",
                  type: "success",
                  onClose: () => {},
                });
                this.handleClose("editForm");
                this.searchForm.pageNo = 1;
                this.getList();
              });
          } else {
            var obj = {
              commodityIdList: this.editForm.commodityIdList,
              storeId: this.editForm.storeId,
              type: this.editForm.type ? 1 : 0,
            };

            this.$axios
              .post("/admin/store/addStoreCommodity", obj)
              .then((res) => {
                this.$message({
                  showClose: true,
                  message: "恭喜你，操作成功",
                  type: "success",
                  onClose: () => {},
                });
                this.handleClose("editForm");
                this.searchForm.pageNo = 1;
                this.getList();
              });
          }
        }
      });
    },
    getList() {
      this.$axios
        .post("/admin/store/getStoreCommodity", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
    handleSet() {
      this.editForm = {
        type: true,
        storeId: null,
        commodityIdList: [],
      };
      this.dialogVisible = true;
    },
    handleClose() {
      this.editForm = {
        storeId: null,
        commodityIdList: [],
      };
      this.fileList = [];
      this.$refs["editForm"].resetFields();
      this.dialogVisible = false;
    },
    handlClose() {
      this.visible = false;
      this.scanvisible = false;
      this.getSearchList("");
    },
    delHandle(row) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/admin/store/delStoreCommodity", {
            storeId: row.storeId,
            commodityIdList: [row.commodityId],
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
            this.getList();
          });
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}

.cus_area {
  margin: 10px;
}
</style>
